export default __webpack_public_path__ + "static/media/import_process.734fd641.PNG";